// extracted by mini-css-extract-plugin
export default {"recordList":"HistoryRecordModalContent_recordList__h7Gj9","recordListItem":"HistoryRecordModalContent_recordListItem__A2eI+","active":"HistoryRecordModalContent_active__C7LTT"};